import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28 25.594V4.586c-1.233.436-1.286.399-2.336.899a15.91 15.91 0 0 0-2.235 1.296c-1.633 1.137-3.539 2.947-4.333 5.563a33.462 33.462 0 0 0-2.714-1.268C13.906 10.051 10.518 9 7 9H6v21c3.873 0 7.49.883 11 2.535V30.34c-2.304-1.008-5.547-2.123-9-2.311V11.03c2.8.17 5.51 1.021 7.618 1.893A30.442 30.442 0 0 1 19 14.57v20.186C23.682 31.976 28.498 30 34 30V9c-1.343 0-2.67.045-4 .264v2.03a18.56 18.56 0 0 1 2-.256v16.99c-3.4.185-6.724 1.232-9.796 2.671 1.44-2.154 3.535-3.872 5.796-5.105ZM24.571 8.423c.51-.355 1.003-.644 1.429-.87v16.88c-1.902 1.19-3.649 2.712-5 4.51V12.956c.604-2.025 2.11-3.517 3.571-4.534Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var PictogramProductMagazine40 = createIcon(IconComponent);